import React from 'react';

export interface LabelProps {
    testId?: string;
    disabled?: boolean;
    value?: string;
    componentId?: string;
}

export const Label: React.FC<LabelProps> = (props) => {
    const { testId, disabled, value, componentId } = props;
    return (
        <label
            data-testid={testId}
            htmlFor={componentId}
            className={`text-label-large font-sans font-medium text-system-on-surface ${disabled ? 'opacity-50' : ''}`}
        >
            {value}
        </label>
    );
};
